import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  ModalHeader,
  Container,
} from "reactstrap";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const ChildInventoryDetails = () => {
   const [modalVisible, setModalVisible] = useState(false);
    const [editedPart, setEditedPart] = useState(null);
   const API_BASE_URL = "https://api.hanoch.in/inventory/update-child-part-stock";
  const [isLoading, setIsLoading] = useState(false);
  const [addInventory, setAddInventory] = useState(null);
  const [childPartData, setChildPartData] = useState([]);
  const [stockData, setStockData] = useState({});
  const [isSubmitEnabled, setIsSubmitEnabled] = useState(false);
  const [partid, setPartid] = useState("");
   const [responseMessage, setResponseMessage] = useState("");
  const [partData, setPartData] = useState([]);
  const [childInventoryData, setChildInventoryData] = useState([]);
 const toggleModal = () => {
    setModalVisible(!modalVisible);
    setEditedPart(null);
  }


  const handleDeletePart = async (id) => {
      try {
        // Make API request to delete the user
        const response = await fetch(
          `https://api.hanoch.in/inventory/update-child-part-stock/${id}/`,
          {
            method: "DELETE",
            // headers: {
            //   Authorization: `Bearer ${authToken}`, // Replace with your actual token
            // },
          }
        );
  
        if (response.ok) {
  
          toast.success("child part deleted successfully");
          fetchChildParts();
        } else if (response.status === 401) {
          // Unauthorized: Log out the user
          localStorage.removeItem("authUser");
          localStorage.removeItem("admin");
        } else {
          toast.error("Error in deleting:", response.statusText);
        }
      } catch (error) {
        console.error("Error deleting:", error);
      }
    };
  const fetchChildInvertory = async () => {
    try {
      setIsLoading(true);
      const response = await fetch("https://api.hanoch.in/inventory/child-part-inventories/", {
        // headers: {
        //   "Content-Type": "application/json",
        //   Authorization: `Bearer ${authToken}`, 
        // },
      });

      if (response.ok) {
        const data = await response.json();
        setChildInventoryData(data);
      } else if (response.status === 401) {
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchPart = async () => {
    try {
      //setIsLoading(true);
      const response = await fetch("https://api.hanoch.in/api/parts");
      if (response.ok) {
        const data = await response.json();
        setPartData(data);
      } else if (response.status === 401) {
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    finally {
      // setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPart();
    fetchChildInvertory();
  }, []);


  const fetchChildParts = async (partid) => {
    try {
      // setIsLoading(true);
      const response = await fetch(`https://api.hanoch.in/api/parts/children/${partid}/`, {
      });
      if (response.ok) {
        const data = await response.json();
        console.log("this is child part data", data);
        setChildPartData(data);
      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        console.error("error fetching child data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching child data:", error);
    }
    finally {
      // setIsLoading(false);
    }
  };

  const [formData, setFormData] = useState({
    partName: "",
    stock_quantity: "",
  });

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };
  const handlePartChange = (event) => {
    const partid = event.target.value;
    setPartid(partid);
    fetchChildParts(partid);
    setStockData({});
  };
  const handleStockChange = (partNumber, value) => {
    const updatedStock = {
      ...stockData,
      [partNumber]: value,
    };
    setStockData(updatedStock);

    // Check if all child parts have stock values filled
    const allFilled = childPartData.every(part => updatedStock[part.part_number] && updatedStock[part.part_number] !== "");
    setIsSubmitEnabled(allFilled);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = childPartData?.map(child => ({
      part_number: child.part_number,
      stock: stockData[child.part_number]
    }));
 const apiUrl = editedPart
      ? `${API_BASE_URL}/${editedPart.id}/`
      : `${API_BASE_URL}/`;
    try {
      const response = await fetch(apiUrl, {
        method: editedPart ? "PUT" : "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        alert("Inventory added successfully!");
         fetchChildInvertory();
           setModalVisible(false);
        setPartid("");
        setChildPartData([]);
        setStockData({});
        setEditedPart(null);
      } else {
        console.error("Submission failed");
      }
    } catch (error) {
      console.error("Submit error:", error);
    }
  };

  const [searchTerm, setSearchTerm] = useState("");
  const handleSearchTermChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // const filteredInventoryData = childInventoryData.filter((data) =>
  //   // machine.company_name.company_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //   data?.child_part?.includes(searchTerm.toLowerCase())
  // );

  const handleInputChangeWrapper = (e) => {
    // Call the original handleInputChange function
    handleInputChange(e);

    // Call the additional function
    fetchChildParts(e.target.value);
    // console.log(e.target.value);
  };

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Calculate the total number of pages
  const totalPages = Math.ceil(childInventoryData.length / itemsPerPage);

  // Calculate the index of the first and last item of the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Get the items for the current page
  const currentItems = childInventoryData.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  // Handle Previous button click
  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Handle Next button click
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  const groupedInventory = currentItems.reduce((acc, curr) => {
    const part = curr.part;
    if (!acc[part]) {
      acc[part] = [];
    }
    acc[part].push(curr);
    return acc;
  }, {});

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Child Part Inventory" />
          <Row>

            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h4 className="card-title mb-0">
                    Add, Edit & Remove Inventory
                  </h4>
                </CardHeader>

                <CardBody>
                  <div id="customerList">
                    <Row className="g-4 mb-3">
                      <Col className="col-sm-auto">
                        <div className="d-flex gap-1">
                          <Button
                            color="success"
                            className="add-btn"
                            onClick={() => toggleModal()}
                            id="create-btn"
                          >
                            <i className="ri-add-line align-bottom me-1"></i>{" "}
                            Add Inventory Details
                          </Button>
                        </div>
                      </Col>
                      <Col className="col-sm">
                        <div className="d-flex justify-content-sm-end">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control search"
                              placeholder="Search..."
                              value={searchTerm}
                              onChange={handleSearchTermChange}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <div className="table-responsive table-card mt-3 mb-1">
                      <table
                        className="table align-middle table-nowrap"
                        id="customerTable"
                      >
                        <thead className="table-light">
                          <tr>
                            <th className="sort" data-sort="email">
                              Date
                            </th>
                            {/* <th className="sort" data-sort="email">
                              part number
                            </th> */}
                            <th className="sort" data-sort="email">
                              Child part number
                            </th>
                            <th className="sort" data-sort="email">
                              Current Stock
                            </th>

                            <th className="sort" data-sort="action">
                              Action
                            </th>
                          </tr>
                        </thead>
                        {/* <tbody className="list form-check-all">
                          {currentItems === undefined ? (
                            <tr>
                              <td colSpan="4" className="text-center">
                                Loading...
                              </td>
                            </tr>
                          ) : currentItems.length === 0 ? (
                            <tr>
                              <td colSpan="4" className="text-center">
                                No content found
                              </td>
                            </tr>
                          ) : (
                            currentItems.map((inventory, index) => (
                              <tr key={index}>
                                 <td className="email">
                                  {inventory.date}
                                </td>
                                <td className="email">
                                  {inventory.part}
                                </td>
                                <td className="email">{inventory.child_part}</td>
                                <td>{inventory.stock_quantity}</td>
                                <td>
                                  <div className="d-flex gap-2">
                                    <div className="edit">
                                      <button
                                        className="btn btn-warning"
                                        onClick={() => {
                                         
                                          setAddInventory(inventory);
                                        }}
                                      >
                                        edit
                                      </button>
                                    </div>
                                   
                                    <div className="remove">
                                      <button
                                        className="btn btn-danger remove-item-btn"
                                        data-bs-toggle="modal"
                                        data-bs-target="#deleteRecordModal"
                                        // onClick={() =>
                                        //   handleDeleteInventory(inventory._id)
                                        // }
                                      >
                                        Delete
                                      </button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody> */}
                        {isLoading ? (
                          <div className="text-center align-items-center">
                            <div className="spinner-border text-primary" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        ) : (
                          <tbody className="list form-check-all">
                            {Object.keys(groupedInventory).length === 0 ? (
                              <tr>
                                <td colSpan="5" className="text-center">No content found</td>
                              </tr>
                            ) : (
                              Object.entries(groupedInventory).map(([part, items], groupIndex) => (
                                <React.Fragment key={groupIndex}>
                                  <tr className="table-primary">
                                    <td colSpan="5">
                                      <strong>Part Number: {part}</strong>
                                    </td>
                                  </tr>
                                  {items.map((item, index) => (
                                    <tr key={index}>
                                      <td>{item.date}</td>

                                      <td>{item.child_part}</td>
                                      <td>{item.stock_quantity}</td>
                                      <td>
                                        <div className="d-flex gap-2">
                                          <div className="edit">
                                            <button
                                              className="btn btn-warning"
                                               onClick={() => {
                                          setModalVisible(true);
                                          setEditedPart(item);
                                        }}
                                            >
                                              Edit
                                            </button>
                                          </div>
                                          <div className="remove">
                                            <button
                                              className="btn btn-danger remove-item-btn"
                                              data-bs-toggle="modal"
                                              data-bs-target="#deleteRecordModal"
                                                onClick={() =>
                                          handleDeletePart(item.id)
                                        }
                                            >
                                              Delete
                                            </button>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </React.Fragment>
                              ))
                            )}
                          </tbody>
                        )}
                      </table>
                      <div className="noresult" style={{ display: "none" }}>
                        <div className="text-center">
                          <lord-icon
                            src="https://cdn.lordicon.com/msoeawqm.json"
                            trigger="loop"
                            colors="primary:#121331,secondary:#08a88a"
                            style={{ width: "75px", height: "75px" }}
                          ></lord-icon>
                          <h5 className="mt-2">Sorry! No Result Found</h5>
                          <p className="text-muted mb-0">
                            We've searched more than 150+ Orders We did not find
                            any orders for you search.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="pagination-wrap hstack gap-2">
                        <Link
                          className={`page-item pagination-prev ${currentPage === 1 ? "disabled" : ""
                            }`}
                          to="#"
                          onClick={handlePrevious}
                        >
                          Previous
                        </Link>
                        <ul className="pagination listjs-pagination mb-0">
                          <li>
                            Page {currentPage} of {totalPages}
                          </li>
                        </ul>
                        <Link
                          className={`page-item pagination-next ${currentPage === totalPages ? "disabled" : ""
                            }`}
                          to="#"
                          onClick={handleNext}
                        >
                          Next
                        </Link>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Add & Edit Child Parts */}

      <Modal
        isOpen={modalVisible}
        toggle={() => {
          setModalVisible(false);
        }}
        centered
      >
        <ModalHeader
          className="bg-light p-3"
          id="exampleModalLabel1"
          toggle={() => {
              toggleModal();
          }}
        >
          {editedPart ? "Edit Inventory details" : "Add inventory details"}
        </ModalHeader>
 {responseMessage && (
          <div
            className={`alert ${responseMessage.includes("Error")
                ? "alert-danger"
                : "alert-success"
              } `}
          >
            {responseMessage}
          </div>
        )}
        <form className="tablelist-form" onSubmit={handleSubmit}>
          <ModalBody>
            {/* <div className="mb-3">
              <label htmlFor="partName" className="form-label">
                Select Machine
              </label>
              <select
                id="machine"
                className="form-control"
                 onChange={handleInputChange}
                value={formData.machine._id}
               
              >
                <option key="default">Select Machine</option>
                
              </select>
            </div> */}
            <div className="mb-3">
              <label htmlFor="partName"
                className="form-label">
                Select Part
              </label>
              <select
                id="partName"
                className="form-control"
                onChange={handlePartChange}
                value={partid}
              >
                <option key="default">Select Part</option>
                {partData?.map((part, index) => (
                  <option key={index} value={part.id}>
                    {part.name}
                  </option>
                ))}
              </select>
            </div>
            {childPartData.length > 0 && (
              <div>
                <h6>Child parts</h6>
                {childPartData?.map((child, index) => (
                  <div className="mb-2" key={index}>
                    <label className="form-lable">
                      {child.part_number}
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter stock"
                      value={stockData[child.part_number] || ""}
                      onChange={(e) => handleStockChange(child.part_number, e.target.value)}
                    />
                  </div>
                ))}
              </div>
            )}

          </ModalBody>
          <ModalFooter>
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => setModalVisible(false)}
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn-success"
                id="add-btn"
                disabled={!isSubmitEnabled}
              >
                {" "}
                {editedPart ? "Update inventory" : "Add inventory"}
              </button>
              {/* <button type="button" className="btn btn-success" id="edit-btn">Update</button> */}
            </div>
          </ModalFooter>
        </form>
      </Modal>

    </React.Fragment>
  );
};

export default ChildInventoryDetails;
